import { render } from "./CustomersTable.vue?vue&type=template&id=4eac537e&ts=true"
import script from "./CustomersTable.vue?vue&type=script&lang=ts"
export * from "./CustomersTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__